import { render, staticRenderFns } from "./Groups.html?vue&type=template&id=671e50bf&scoped=true&external"
import script from "./Groups.js?vue&type=script&lang=js&external"
export * from "./Groups.js?vue&type=script&lang=js&external"
import style0 from "./Groups.scss?vue&type=style&index=0&id=671e50bf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671e50bf",
  null
  
)

export default component.exports